export default __webpack_public_path__ + "assets/images/d5e048aa2bd7a4e78f66ad6317cd1ee5.webp";